import { Injectable, Inject } from '@angular/core';
import { LOGGER } from '../../models/configuration.model';
import { ILogger } from './i-logger';

@Injectable()
export class AggregatedLoggerService extends ILogger {
  public constructor(@Inject(LOGGER) private readonly loggers: ILogger[]) {
    super();
  }
  // User tracking
  public setUser(identifier: string, email: string): void {
    this.forEachLogger((logger) => logger.setUser(identifier, email));
  }
  public resetUser(): void {
    this.forEachLogger((logger) => logger.resetUser());
  }

  public action<T>(actionType: string, payload: T) {
    this.forEachLogger((logger) => logger.action(actionType, payload));
  }
  // NAVIGATION
  public navigation(path: string) {
    this.forEachLogger((logger) => logger.navigation(path));
  }

  // Custom log for components
  public debug(message: any, optionalParameters?: any[]): void {
    this.forEachLogger((logger) => logger.debug(message, optionalParameters));
  }
  public info(message: any, optionalParameters?: any[]): void {
    this.forEachLogger((logger) => logger.info(message, optionalParameters));
  }
  public warn(message: any, optionalParameters?: any[]): void {
    this.forEachLogger((logger) => logger.warn(message, optionalParameters));
  }
  public error(message: any, optionalParameters?: any[]): void {
    this.forEachLogger((logger) => logger.error(message, optionalParameters));
  }

  public exception(error: Error) {
    this.forEachLogger((logger) => logger.exception(error));
  }

  private forEachLogger(log: (logger: ILogger) => void) {
    for (const logger of this.loggers) {
      if (logger.isEnabled) {
        this.addToQueue(() => log(logger));
      }
    }
  }

  private addToQueue(method: () => void): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        method();
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
}
